import * as React from 'react';
import { getTestAttributes } from '@common/utils/tests';
import { Switch as SwitchBase } from '@common/components/switch';
import { MODULE_NAME } from '@modules/fhq-design-tool/constants/shared';
import { Field, FieldLayout } from '../field';
import cx from 'classnames';
import { IInputComponent } from '@modules/fhq-design-tool/types/input-component';

import './switch.styles.scss';

export type SwitchProps = IInputComponent<boolean> & {
  labelWidth?: number;
  label: string;
  layout?: FieldLayout;
};

export const Switch: React.FC<SwitchProps> = (props) => {
  const { className, disabled, label, labelWidth, onChange, value, metadata, description, required, margin, layout } = props;

  return (
    <Field 
      layout={layout}
      labelWidth={labelWidth} 
      label={label} 
      disabled={disabled}
      className={cx('FhqDesignToolSwitch', className)}
      description={description}
      required={required}
      margin={margin}
      inputWidth="auto"
    >
      <SwitchBase 
        {...getTestAttributes(MODULE_NAME, metadata.description, 'checkbox')}
        checked={value} 
        className="FhqDesignToolSwitch__input"
        onChange={onChange} 
      />
    </Field>
  );
};